export function getConfig (key: string): string | void {
  const container = document.querySelector('#app-config')
  if (!container) {
    console.error('Error getConfig: element #app-config is null')
  } else {
    const attrValue = container.getAttribute('data-config')
    if (!attrValue) {
      console.error('Error getConfig: attr data-config is null')
    } else {
      const config = JSON.parse(window.atob(attrValue))
      return config[key]
    }
  }
}
